import { useNavigate } from 'react-router-dom';
import { useI18n } from '../../../../../i18n';
import { type PersonaDetalle } from '../../../../shared/services/api';
import { cardStyle, type ActivoItem } from './persona-detail-shared';

export function PersonaActivosTab({ data }: { data: PersonaDetalle }) {
  const { t } = useI18n();
  const navigate = useNavigate();
  // Activos come from persona relation (if available)
  const activos: ActivoItem[] =
    (data.persona as unknown as { activos?: ActivoItem[] }).activos ?? [];

  return (
    <div style={cardStyle}>
      <h3 style={{ margin: '0 0 12px', fontSize: 14, color: 'var(--color-primario)' }}>
        Activos Asignados
      </h3>
      {activos.length === 0 ? (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '40px 20px',
            gap: 16,
          }}
        >
          <svg
            width="48"
            height="48"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#9CA3AF"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z" />
            <polyline points="3.27 6.96 12 12.01 20.73 6.96" />
            <line x1="12" y1="22.08" x2="12" y2="12" />
          </svg>
          <p style={{ fontSize: 14, color: '#5A6171', textAlign: 'center', margin: 0 }}>
            {t.people.assetsPlaceholder ??
              'Los activos asignados a esta persona se gestionan desde el modulo V·IA Inventario.'}
          </p>
          <button
            onClick={() => navigate('/inventario')}
            style={{
              padding: '8px 20px',
              border: 'none',
              borderRadius: 8,
              background: '#2F5496',
              color: '#fff',
              fontSize: 13,
              fontWeight: 600,
              cursor: 'pointer',
              fontFamily: 'inherit',
            }}
          >
            {t.people.goToInventory ?? 'Ir a Inventario'}
          </button>
        </div>
      ) : (
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ backgroundColor: '#0E243E' }}>
              <th
                style={{
                  textAlign: 'left',
                  padding: '14px 20px',
                  color: '#fff',
                  fontWeight: 700,
                  fontSize: 12,
                  textTransform: 'uppercase',
                  letterSpacing: '0.8px',
                }}
              >
                Activo
              </th>
              <th
                style={{
                  textAlign: 'left',
                  padding: '14px 20px',
                  color: '#fff',
                  fontWeight: 700,
                  fontSize: 12,
                  textTransform: 'uppercase',
                  letterSpacing: '0.8px',
                }}
              >
                Codigo
              </th>
              <th
                style={{
                  textAlign: 'left',
                  padding: '14px 20px',
                  color: '#fff',
                  fontWeight: 700,
                  fontSize: 12,
                  textTransform: 'uppercase',
                  letterSpacing: '0.8px',
                }}
              >
                Estado
              </th>
            </tr>
          </thead>
          <tbody>
            {activos.map((a) => (
              <tr key={a.id} style={{ borderBottom: '1px solid #F2F4F6' }}>
                <td style={{ padding: '14px 20px', fontSize: 14 }}>{a.nombre}</td>
                <td style={{ padding: '14px 20px', fontSize: 14 }}>{a.codigo}</td>
                <td style={{ padding: '14px 20px', fontSize: 14 }}>{a.estado}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
